import React from "react";
import styles from "./formItem.module.scss";

interface FormItemProps {
  children: React.ReactNode;
}

/**
 * Form items are used for any kind of form input. It consists on a combination of components (compounded together) that
 * provide all the information to the user of what he needs to enter. These components are usually the label, the input (or select or other field)
 * and a description that helps the user in giving information on what is needed for that particular field.
 */
export const FormItem = ({ children }: FormItemProps) => {
  return <div className={styles.formItem}>{children}</div>;
};
export default FormItem;
